export default "<div>\n    {{ZoneInComponent?.Nom}}\n</div>";